<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE PA'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-4">
          <label>
            <small
              v-show="form.numero.required"
              class="text-danger"
            >
              *
            </small>
            Código:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Código do PA'"
              v-model="form.numero.value"
              :size="form.numero.maxlength"
              :required="form.numero.required"
              :state="form.numero.state"
              autocomplete="false"
            ></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label>
            <small
              v-if="form.descricao.required"
              class="text-danger"
            >
              *
            </small>
            PA:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Nome do PA'"
              v-model="form.descricao.value"
              :size="form.descricao.maxlength"
              :required="form.descricao.required"
              :state="form.descricao.state"
            ></b-form-input>
          </div>
        </div>

        <div class="col-md-4">
          <label>
            <small
              v-if="form.regionalId.required"
              class="text-danger"
            >
              *
            </small>
            Regional:
          </label>
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fas fa-store-alt"> </i>
            </span>
            <b-form-select
              v-model="form.regionalId.value"
              :options="form.regionalId.options"
            >
              <template slot="first">
                <option :value="''">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-4">
          <label>
            <small
              v-if="form.gerenteId.required"
              class="text-danger"
            >
              *
            </small>
            Gerente Geral:
          </label>
          <div class="input-group">
            <v-select
              v-model="form.gerenteId.value"
              :options="form.gerenteId.options"
              class="w-100"
              label="text"
              :reduce="(opt) => opt.value"
            >
              <template v-slot:no-options>
                Nenhum funcionário encontrado.
              </template>
            </v-select>
          </div>
        </div>

        <div class="col-md-4">
          <label
            ><small
              v-if="form.funcionariosId.required"
              class="text-danger"
              >*</small
            >
            Funcionários:</label
          >
          <div class="input-group">
            <v-select
              v-model="form.funcionariosId.value"
              :options="form.funcionariosId.options"
              class="w-100"
              label="text"
              multiple
              :reduce="(opt) => opt.value"
            >
              <template v-slot:no-options
                >Nenhum funcionário encontrado.</template
              >
            </v-select>
          </div>
        </div>

        <div class="col-md-4">
          <label>
            <small
              v-if="form.codigoOmniChannel.required"
              class="text-danger"
            >
              *
            </small>
            Código Omnichannel:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o código do canal Omnichannel'"
              v-model="form.codigoOmniChannel.value"
              :maxlength="form.codigoOmniChannel.maxlength"
              :required="form.codigoOmniChannel.required"
              :state="form.codigoOmniChannel.state"
            ></b-form-input>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-4">
          <NxInputCooperativa
            :value="this.form.cooperativa.value"
            @update:value="handleInputUpdate('cooperativa', $event, false)"
          />
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import 'vue-select/dist/vue-select.css'

import FuncionarioRepository from '@/shared/http/repositories/configurations/employee.js'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import RegionalRepository from '@/shared/http/repositories/configurations/regional.js'
import PaModel from '@/shared/models/configurations/pamodel.js'
import PaForms from './pa-form.js'

import { NxInputCooperativa } from '@/components/nexum/components/custom-inputs/index.js'

export default {
  name: 'PaAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: PaModel,
      form: PaForms
    }
  },
  components: { NxInputCooperativa },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
      this.loadFuncionarioNames()
      this.loadRegionalNames()
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj.gerente && obj.gerente.id) {
        this.form.gerenteId.value = obj.gerente.id
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      PARepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      PARepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    loadFuncionarioNames () {
      loading.push()
      FuncionarioRepository.GetAll()
        .then((response) => {
          const funcionariosList = this.onResultDropdown(
            response,
            null,
            (f) => f.pessoa.nome
          )
          this.form.gerenteId.options = funcionariosList
          this.form.funcionariosId.options = funcionariosList
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    loadRegionalNames () {
      loading.push()
      RegionalRepository.GetAll()
        .then((response) => {
          this.form.regionalId.options = this.onResultDropdown(
            response,
            null,
            (f) => f.nome
          )
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName].value = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (field) {
      this.form[field].value = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/pa/components/add/paadd.vue